import { routeList } from '@/router/helpers/routes'
/* Views */
import ValidateSession from '@/views/initialActions/ValidateSession'
import FirstLogin from '@/views/initialActions/FirstLogin'
import ChooseDefaultContractAccountGroup from '@/views/initialActions/ChooseDefaultContractAccountGroup'
import DefinitionsSecureAssociationEnrollment from '@/views/userArea/definitions/SecureAssociationEnrollment'

export default [{
	path: routeList.INITIAL_ACTIONS_VALIDATE_SESSION_PATH,
	name: routeList.INITIAL_ACTIONS_VALIDATE_SESSION_NAME,
	component: ValidateSession
}, {
	path: routeList.INITIAL_ACTIONS_FIRST_LOGIN_PATH,
	name: routeList.INITIAL_ACTIONS_FIRST_LOGIN_NAME,
	component: FirstLogin
}, {
	path: routeList.INITIAL_ACTIONS_CHOOSE_DEFAULT_CONTRACT_ACCOUNT_GROUP_PATH,
	name: routeList.INITIAL_ACTIONS_CHOOSE_DEFAULT_CONTRACT_ACCOUNT_GROUP_NAME,
	component: ChooseDefaultContractAccountGroup
}, {
	path: routeList.INITIAL_ACTIONS_SHOW_SECURE_ASSOCIATION_ENROLLMENT_PATH,
	name: routeList.INITIAL_ACTIONS_SHOW_SECURE_ASSOCIATION_ENROLLMENT_NAME,
	component: DefinitionsSecureAssociationEnrollment
}]
